module.exports = __webpack_public_path__ + "static/img/7.82b241e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/7.jpg
// module id = CUx3
// module chunks = 15